import { useState, useEffect } from "react";
import React from "react";
import { NavLink } from "react-router-dom";
import { spacing } from "@mui/system";
import { userLogin, userRedirectLogin } from "../../Services/UserUtil";
import Button from "@mui/material/Button";
import { Hidden } from "@mui/material";

import ivplogo from "/app/images/logo/ivplogo.webp";
import Cookies from "js-cookie";
import useStyles from "../../components/Forms/user-jss";
import InstituteCat from "./InstitueCat";
import InstituteList from "./InstituteList";
import Services from "/app/Services/Services";
import satyamevImage from "/app/images/logo/satyamev.webp";
import meityImage from "/app/images/logo/meity.webp";
import iseaMobile from "/app/images/iseapmu.webp";
import keycloakData from "../../api/apps/keycloakData";
import "./HomeNavbar.css";

const HomeNavbar = (props) => {
  const { slideMode } = props;
  const [click, setClick] = useState(false);
  const { classes, cx } = useStyles();
  const isAuth = Cookies.get("ac_token");
  const role = localStorage.getItem("Role");

  const [getAllInstitute, setAllInstitute] = useState([]);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  const loginSubmit = () => {
    const bodyjson = {
      client: keycloakData.ivp_clientID,
      // client: keycloakData.ivpConference_clientID,
    };
    userRedirectLogin(bodyjson.client);
    // userLogin();
  };

  useEffect(() => {
    Services.getAllInstitutes()
      .then(async (response) => {
        // console.log("get All Institutes", response);
        const allInstitutes = response.data;
        setAllInstitute(allInstitutes);
      })
      .catch((error) => {
        // console.log("topic error", error);
      });
  }, []);

  return (
    <div>
      <div className={click ? "main-container" : ""} onClick={() => Close()} />
      <nav className="navbar" onClick={(e) => e.stopPropagation()}>
        <div className={slideMode ? classes.fullWidth : classes.container}>
          <div className={`nav-container ${classes.root}`}>
            {/* <div className="d-flex align-items-center header-nav-logo"> */}
            <NavLink exact to="/" className="nav-logo navImg ">
              <div className="d-flex desktopViewLogo align-items-center">
                <img src={meityImage} alt="ISEA" className="satyamevImage" />
                <span className={classes.logoSaperator}></span>
                <img src={ivplogo} alt="IVP logo" className="ivp-logo" />
              </div>
              <div className="mobileViewLogo">
                <img
                  src={satyamevImage}
                  alt="ISEA"
                  className="satyamevImage1"
                />
                <span className={classes.logoSaperator}></span>
                <img src={iseaMobile} alt="IVP logo" className="ivp-logo1" />
              </div>
            </NavLink>
            {/* </div> */}
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <NavLink
                  exact
                  to="/"
                  activeClassName="active"
                  className="nav-links"
                  onClick={click ? handleClick : null}
                >
                  Home
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink
                  exact
                  to="/services_resources"
                  activeClassName="active"
                  className="nav-links"
                  onClick={click ? handleClick : null}
                >
                  Services
                </NavLink>
              </li> */}
              {/* <li className="nav-item">
                <NavLink
                  exact
                  to="/new_service"
                  activeClassName="active"
                  className="nav-links"
                  onClick={click ? handleClick : null}
                >
                  Services
                </NavLink>
              </li> */}
              {/* <li className="nav-item">
                <a
                  href="#services"
                  onClick={(e) => {
                    e.preventDefault();
                    const servicesSection = document.getElementById("services");
                    servicesSection.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="nav-links"
                >
                  Service
                </a>
              </li> */}
              <li className="nav-item">
                <NavLink
                  exact
                  to="/about"
                  activeClassName="active"
                  className="nav-links"
                  // onClick={click ? handleClick : null}
                >
                  About
                </NavLink>
              </li>

              {/* <li className="nav-item">
                <NavLink
                  exact
                  to="/thematic-clusters"
                  activeClassName="active"
                  className="nav-links"
                  // onClick={click ? handleClick : null}
                >
                  Thematic Clusters
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  exact
                  to="/"
                  activeClassName="active"
                  className="nav-links"
                  // onClick={click ? handleClick : null}
                >
                  Institutes
                </NavLink>
                <ul className="submenu px-2">
                  <li>
                    <InstituteCat />
                    <InstituteList getAllInstituteList={getAllInstitute} />
                  </li>
                </ul>
              </li> */}
              {/* <li className="nav-item">
                <NavLink
                  exact
                  to="/spokesInstituteRegistration"
                  activeClassName="active"
                  className="nav-links"
                  // onClick={click ? handleClick : null}
                >
                  Spokes Institutes
                </NavLink>
              </li> */}
              {/* <li className="nav-item">
                <NavLink
                  exact
                  to="/virtual-conference"
                  activeClassName="active"
                  className="nav-links"
                 
                >
                  Conference
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink
                  exact
                  to="/contact"
                  activeClassName="active"
                  className="nav-links"
                  // onClick={click ? handleClick : null}
                >
                  Contact Us
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink
                  exact
                  to="/raise-issue"
                  activeClassName="active"
                  className="nav-links"
                  // onClick={click ? handleClick : null}
                >
                  Raine an issue
                </NavLink>
              </li> */}
            </ul>
            <div className="header">
              <nav className="menu--left" role="navigation">
                <div className="menuToggle">
                  <input type="checkbox" />
                  <span></span>
                  <span></span>
                  <span></span>
                  <ul className="menuItem">
                    <li>
                      <a href="#">Home</a>
                    </li>
                    <li>
                      <a href="#">About</a>
                    </li>
                    <li>
                      <a href="#">Info</a>
                    </li>
                    <li>
                      <a href="#">Contact</a>
                    </li>
                    <li>
                      <a href="#">Show me more</a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>

            <div className="nav-icon" onClick={handleClick}>
              <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
            </div>
            {isAuth && (
              <>
                <div className={` mx-2 ${classes.registerBtn}`}>
                  {role === "admin" ? (
                    <NavLink exact to="/administrator/dashboard">
                      <Hidden>
                        <Button className="text-white">Dashboard</Button>
                      </Hidden>
                    </NavLink>
                  ) : role === "user" ? (
                    <NavLink exact to="/user/dashboard">
                      <Hidden>
                        <Button className="text-white">Dashboard</Button>
                      </Hidden>
                    </NavLink>
                  ) : role === "pmu_admin" ? (
                    <NavLink exact to="/pmu/dashboard">
                      <Hidden>
                        <Button className="text-white">Dashboard</Button>
                      </Hidden>
                    </NavLink>
                  ) : role === "super_admin" ? (
                    <NavLink exact to="/management/dashboard">
                      <Hidden>
                        <Button className="text-white">Dashboard</Button>
                      </Hidden>
                    </NavLink>
                  ) : role === "coordinator" ? (
                    <NavLink exact to="/ic/dashboard">
                      <Hidden>
                        <Button className="text-white">Dashboard</Button>
                      </Hidden>
                    </NavLink>
                  ) : (
                    <NavLink exact to="/meity-management/dashboard">
                      <Hidden>
                        <Button className="text-white">Dashboard</Button>
                      </Hidden>
                    </NavLink>
                  )}
                </div>
              </>
            )}

            {!isAuth && (
              <>
                {/* <div className="authBtn"> */}
                {/* <div className={` mx-2 ${classes.registerBtn1}`}>
                  <NavLink exact to="/user-registration">
                    <Hidden>
                      <Button
                        variant="contained"
                        color="primary"
                        className="text-white"
                      >
                        Register
                      </Button>
                    </Hidden>
                  </NavLink>
                </div> */}
                <div className={` mx-2 ${classes.btnLogin1}`}>
                  <Button
                    variant="contained"
                    color="primary"
                    className="text-white"
                    onClick={loginSubmit}
                  >
                    Login
                  </Button>
                  {/* <a exact
                  //  to="/otp_registration"
                  target="_blank"
                   href={`http://${redirectURL}`}
                  > */}
                  {/* <Hidden>
                      <Button
                        variant="contained"
                        color="primary"
                        className="text-white"
                      >
                        Login
                      </Button>
                    </Hidden> */}
                  {/* </a> */}
                </div>

                {/* </div> */}
              </>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};
export default HomeNavbar;
